"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  KeyboardOptionAlternate: ['keyboard-option-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.118.082H4.882a4.8,4.8,0,0,0-4.8,4.8V19.114a4.8,4.8,0,0,0,4.8,4.8H19.118a4.8,4.8,0,0,0,4.8-4.8V4.878A4.8,4.8,0,0,0,19.118.082Zm2.8,19.032a2.8,2.8,0,0,1-2.8,2.8H4.882a2.8,2.8,0,0,1-2.8-2.8V4.878a2.8,2.8,0,0,1,2.8-2.8H19.118a2.8,2.8,0,0,1,2.8,2.8Z', 'M19.414,15.5H16.328a1,1,0,0,1-.707-.293L9.5,9.081A2,2,0,0,0,8.086,8.5H4.414a1,1,0,1,0,0,2H7.671a1,1,0,0,1,.708.293L14.5,16.91a2,2,0,0,0,1.414.586h3.5a1,1,0,1,0,0-2Z', 'M19.414,8.5H14.5a1,1,0,0,0,0,2h4.914a1,1,0,0,0,0-2Z']],
  KeyboardReturnAlternate: ['keyboard-return-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.174,0H4.826A4.832,4.832,0,0,0,0,4.822V19.17A4.832,4.832,0,0,0,4.826,24H19.174A4.832,4.832,0,0,0,24,19.17V4.822A4.832,4.832,0,0,0,19.174,0ZM22,19.17A2.83,2.83,0,0,1,19.174,22H4.826A2.829,2.829,0,0,1,2,19.17V4.822A2.828,2.828,0,0,1,4.826,2H19.174A2.829,2.829,0,0,1,22,4.822Z', 'M17.5,7.5a1,1,0,0,0-1,1v2.75a.25.25,0,0,1-.25.25h-5.5a.25.25,0,0,1-.25-.25V9.5a1,1,0,0,0-1.707-.707l-3,3a1,1,0,0,0,0,1.414l3,3A1,1,0,0,0,10.5,15.5v-1.75a.25.25,0,0,1,.25-.25H16.5a2,2,0,0,0,2-2v-3A1,1,0,0,0,17.5,7.5Z']],
  KeyboardAlt: ['keyboard-alt', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.278 12.747L8.722 12.747 8 10.727 7.278 12.747z', 'M19.5.5H4.5a4.012,4.012,0,0,0-4,4v15a4.011,4.011,0,0,0,4,4h15a4.011,4.011,0,0,0,4-4V4.5A4.012,4.012,0,0,0,19.5.5ZM10.752,16.2a.738.738,0,0,1-.252.043.749.749,0,0,1-.706-.5l-.477-1.336a.252.252,0,0,0-.236-.166H6.919a.252.252,0,0,0-.236.166l-.477,1.336a.749.749,0,1,1-1.412-.5l2.5-7a.749.749,0,0,1,1.412,0l2.5,7A.748.748,0,0,1,10.752,16.2Zm3.5-.707a.75.75,0,0,1-1.5,0v-7a.75.75,0,0,1,1.5,0ZM19,11.247h-.5a.25.25,0,0,0-.25.25v3a.25.25,0,0,0,.25.25.75.75,0,0,1,0,1.5,1.752,1.752,0,0,1-1.75-1.75v-3a.25.25,0,0,0-.25-.25H16a.75.75,0,0,1,0-1.5h.5a.249.249,0,0,0,.25-.25v-1a.75.75,0,0,1,1.5,0v1a.249.249,0,0,0,.25.25H19a.75.75,0,0,1,0,1.5Z']],
  KeyboardShiftAlternate: ['keyboard-shift-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.174,0H4.826A4.832,4.832,0,0,0,0,4.822V19.17A4.832,4.832,0,0,0,4.826,24H19.174A4.832,4.832,0,0,0,24,19.17V4.822A4.832,4.832,0,0,0,19.174,0ZM22,19.17A2.83,2.83,0,0,1,19.174,22H4.826A2.829,2.829,0,0,1,2,19.17V4.822A2.828,2.828,0,0,1,4.826,2H19.174A2.829,2.829,0,0,1,22,4.822Z', 'M12.376,4.926a.5.5,0,0,0-.753,0l-5.9,6.741A.5.5,0,0,0,6.1,12.5H9.249a.25.25,0,0,1,.25.25V19a.5.5,0,0,0,.5.5h4a.5.5,0,0,0,.5-.5v-6.25a.25.25,0,0,1,.25-.25H17.9a.5.5,0,0,0,.376-.829Z']],
  KeyboardEject: ['keyboard-eject', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.5.5H4.5a4.012,4.012,0,0,0-4,4v15a4.011,4.011,0,0,0,4,4h15a4.011,4.011,0,0,0,4-4V4.5A4.012,4.012,0,0,0,19.5.5ZM5.289,11.155l6.346-6.768a.5.5,0,0,1,.73,0l6.346,6.768a.5.5,0,0,1-.365.842H5.654a.5.5,0,0,1-.365-.842ZM19.5,18a.5.5,0,0,1-.5.5H5a.5.5,0,0,1-.5-.5V15a.5.5,0,0,1,.5-.5H19a.5.5,0,0,1,.5.5Z']],
  KeyboardDelete: ['keyboard-delete', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.5.5H4.5a4.012,4.012,0,0,0-4,4v15a4.011,4.011,0,0,0,4,4h15a4.011,4.011,0,0,0,4-4V4.5A4.012,4.012,0,0,0,19.5.5Zm0,14.5A1.5,1.5,0,0,1,18,16.5H8.207a1.494,1.494,0,0,1-1.061-.439l-3-3a1.5,1.5,0,0,1,0-2.121l3-3A1.5,1.5,0,0,1,8.207,7.5H18A1.5,1.5,0,0,1,19.5,9Z', 'M10.97,14.028a.751.751,0,0,0,1.06,0l.793-.793a.25.25,0,0,1,.354,0l.793.793a.75.75,0,0,0,1.06-1.061l-.793-.793a.25.25,0,0,1,0-.353l.793-.793a.75.75,0,0,0-1.06-1.061l-.793.793a.25.25,0,0,1-.354,0l-.793-.793a.75.75,0,1,0-1.06,1.061l.793.793a.25.25,0,0,1,0,.353l-.793.793A.75.75,0,0,0,10.97,14.028Z']],
  KeyboardOption: ['keyboard-option', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.414,4.553a3.982,3.982,0,0,0-3.97-3.97H4.556a3.982,3.982,0,0,0-3.97,3.97V19.441a3.982,3.982,0,0,0,3.97,3.971H19.444a3.982,3.982,0,0,0,3.97-3.971Zm-4,12.945h-3.5a2,2,0,0,1-1.415-.586L8.379,10.791a1,1,0,0,0-.707-.293H4.414a1,1,0,1,1,0-2H8.086A2,2,0,0,1,9.5,9.083l6.121,6.122a1,1,0,0,0,.707.293h3.086a1,1,0,0,1,0,2Zm0-7H14.5a1,1,0,0,1,0-2h4.914a1,1,0,0,1,0,2Z']],
  KeyboardReturn1: ['keyboard-return-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.5.5H4.5a4.012,4.012,0,0,0-4,4v15a4.011,4.011,0,0,0,4,4h15a4.011,4.011,0,0,0,4-4V4.5A4.012,4.012,0,0,0,19.5.5Zm-12,14a1,1,0,0,1-2,0v-6a1,1,0,0,1,2,0Zm11-2H14.25a.25.25,0,0,0-.25.25V14.5a1,1,0,0,1-.617.924,1,1,0,0,1-1.09-.217l-3-3a1,1,0,0,1,0-1.414l3-3A1,1,0,0,1,14,8.5v1.75a.249.249,0,0,0,.25.25H18.5a1,1,0,0,1,0,2Z']],
  KeyboardShift: ['keyboard-shift', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.5.5H4.5a4.012,4.012,0,0,0-4,4v15a4.011,4.011,0,0,0,4,4h15a4.011,4.011,0,0,0,4-4V4.5A4.012,4.012,0,0,0,19.5.5ZM18.353,12.2a.5.5,0,0,1-.455.293H14.749a.25.25,0,0,0-.25.25V19a.5.5,0,0,1-.5.5H10a.5.5,0,0,1-.5-.5v-6.25a.25.25,0,0,0-.25-.25H6.1a.5.5,0,0,1-.376-.829l5.9-6.74a.5.5,0,0,1,.752,0l5.9,6.74A.5.5,0,0,1,18.353,12.2Z']],
  KeyboardPowerOff: ['keyboard-power-off', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.5.5H4.5a4.012,4.012,0,0,0-4,4v15a4.011,4.011,0,0,0,4,4h15a4.011,4.011,0,0,0,4-4V4.5A4.012,4.012,0,0,0,19.5.5ZM4.5,5A.5.5,0,0,1,5,4.5H9a.5.5,0,0,1,.353.854L8.238,6.467a.252.252,0,0,0,0,.354l4.469,4.469A1,1,0,1,1,11.293,12.7L6.824,8.235a.25.25,0,0,0-.353,0L5.354,9.351A.5.5,0,0,1,5,9.5a.489.489,0,0,1-.191-.038A.5.5,0,0,1,4.5,9ZM12,20.5a8.538,8.538,0,0,1-8.312-6.719,1,1,0,1,1,1.955-.418,6.5,6.5,0,1,0,7.633-7.738,1,1,0,1,1,.391-1.96A8.5,8.5,0,0,1,12,20.5Z']],
  KeyboardReturn: ['keyboard-return', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.5.5H4.5a4.012,4.012,0,0,0-4,4v15a4.011,4.011,0,0,0,4,4h15a4.011,4.011,0,0,0,4-4V4.5A4.012,4.012,0,0,0,19.5.5Zm-1,11a2,2,0,0,1-2,2H10.75a.25.25,0,0,0-.25.25V15.5a1,1,0,0,1-.617.924,1,1,0,0,1-1.09-.217l-3-3a1,1,0,0,1,0-1.414l3-3A1,1,0,0,1,10.5,9.5v1.75a.249.249,0,0,0,.25.25h5.5a.249.249,0,0,0,.25-.25V8.5a1,1,0,0,1,2,0Z']],
  KeyboardArrowTopLeft: ['keyboard-arrow-top-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.971,15.847,6.48,4.356A.249.249,0,0,1,6.48,4l2.3-2.3A1,1,0,0,0,8.071,0H1A1,1,0,0,0,0,1V8.069a1,1,0,0,0,1.707.707l2.3-2.3a.252.252,0,0,1,.354,0L15.85,17.968a1.5,1.5,0,0,0,2.121-2.121Z']],
  KeyboardButtonAlternate: ['keyboard-button-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.174,0H4.826A4.832,4.832,0,0,0,0,4.822V19.17A4.832,4.832,0,0,0,4.826,24H19.174A4.832,4.832,0,0,0,24,19.17V4.822A4.832,4.832,0,0,0,19.174,0ZM22,19.17A2.83,2.83,0,0,1,19.174,22H4.826A2.829,2.829,0,0,1,2,19.17V4.822A2.828,2.828,0,0,1,4.826,2H19.174A2.829,2.829,0,0,1,22,4.822Z']],
  KeyboardArrowReturn: ['keyboard-arrow-return', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.147,1.952H12.238a1.5,1.5,0,0,0,0,3h3.909a4.852,4.852,0,1,1,0,9.7H7.137a.25.25,0,0,1-.25-.25V11.27a1,1,0,0,0-1.707-.707L.293,15.449a1,1,0,0,0,0,1.414L5.18,21.75a1,1,0,0,0,1.707-.707V17.906a.25.25,0,0,1,.25-.25h9.01a7.852,7.852,0,1,0,0-15.7Z']],
  KeyboardArrowNext: ['keyboard-arrow-next', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.661,5.563a1,1,0,0,0-1.707.707v3.978a.25.25,0,0,1-.25.25H1.5a1.5,1.5,0,0,0,0,3H11.7a.25.25,0,0,1,.25.25v3.977a1,1,0,0,0,1.707.707l5.728-5.727a1,1,0,0,0,0-1.414Z', 'M22.5,4.77A1.5,1.5,0,0,0,21,6.27V17.725a1.5,1.5,0,0,0,3,0V6.27A1.5,1.5,0,0,0,22.5,4.77Z']],
  KeyboardArrowDown: ['keyboard-arrow-down', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.7,17.838a1,1,0,0,0-.924-.617H13.75a.249.249,0,0,1-.25-.25V1.5a1.5,1.5,0,0,0-3,0V16.971a.25.25,0,0,1-.25.25H7.222a1,1,0,0,0-.707,1.707l4.777,4.778a1,1,0,0,0,1.415,0l4.778-4.778A1,1,0,0,0,17.7,17.838Z']],
  KeyboardArrowPrevious: ['keyboard-arrow-previous', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,10.5H12.3a.25.25,0,0,1-.25-.25V6.27a1,1,0,0,0-1.707-.707L4.611,11.291a1,1,0,0,0,0,1.414l5.728,5.727a1,1,0,0,0,.707.293,1,1,0,0,0,1-1V13.748a.25.25,0,0,1,.25-.25H22.5a1.5,1.5,0,0,0,0-3Z', 'M1.5,4.77A1.5,1.5,0,0,0,0,6.27V17.725a1.5,1.5,0,0,0,3,0V6.27A1.5,1.5,0,0,0,1.5,4.77Z']],
  KeyboardArrowRight: ['keyboard-arrow-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.707,11.291,18.929,6.513a1,1,0,0,0-1.707.707v3.028a.25.25,0,0,1-.25.25H1.5a1.5,1.5,0,0,0,0,3H16.972a.25.25,0,0,1,.25.25v3.028a1,1,0,0,0,1.707.707l4.778-4.778a1,1,0,0,0,0-1.414Z']],
  KeyboardButton: ['keyboard-button', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0.500 0.497 L23.500 0.497 L23.500 23.497 L0.500 23.497 Z']],
  KeyboardAsterisk3: ['keyboard-asterisk-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,10.459H15.053a.25.25,0,0,1-.216-.375l3.95-6.842a1.5,1.5,0,1,0-2.6-1.5L12.217,8.623a.251.251,0,0,1-.434,0L7.811,1.742a1.5,1.5,0,0,0-2.6,1.5l3.95,6.842a.25.25,0,0,1-.216.375H1.5a1.5,1.5,0,0,0,0,3H8.992a.25.25,0,0,1,.216.375l-3.995,6.92a1.5,1.5,0,1,0,2.6,1.5l3.972-6.881a.251.251,0,0,1,.434,0l3.972,6.881a1.5,1.5,0,1,0,2.6-1.5l-3.995-6.92a.25.25,0,0,1,.216-.375H22.5a1.5,1.5,0,0,0,0-3Z']],
  KeyboardButtonDirection: ['keyboard-button-direction', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8,11h8a1.5,1.5,0,0,0,1.5-1.5v-8A1.5,1.5,0,0,0,16,0H8A1.5,1.5,0,0,0,6.5,1.5v8A1.5,1.5,0,0,0,8,11ZM9.5,5.5a.5.5,0,0,1-.354-.853l2.5-2.5a.5.5,0,0,1,.708,0l2.5,2.5A.5.5,0,0,1,14.5,5.5H13a.25.25,0,0,0-.25.25V8.482a.75.75,0,0,1-1.5,0V5.747A.25.25,0,0,0,11,5.5Z', 'M9.5,13h-8A1.5,1.5,0,0,0,0,14.5v8A1.5,1.5,0,0,0,1.5,24h8A1.5,1.5,0,0,0,11,22.5v-8A1.5,1.5,0,0,0,9.5,13Zm-1.016,4.75a.75.75,0,1,1,0,1.5H5.75a.25.25,0,0,0-.25.25V21a.5.5,0,0,1-.309.462A.489.489,0,0,1,5,21.5a.5.5,0,0,1-.354-.146l-2.5-2.5a.5.5,0,0,1,0-.707l2.5-2.5A.5.5,0,0,1,5.5,16v1.5a.249.249,0,0,0,.25.25Z', 'M22.5,13h-8A1.5,1.5,0,0,0,13,14.5v8A1.5,1.5,0,0,0,14.5,24h8A1.5,1.5,0,0,0,24,22.5v-8A1.5,1.5,0,0,0,22.5,13Zm-6.984,6.25a.75.75,0,1,1,0-1.5H18.25a.249.249,0,0,0,.25-.25V16a.5.5,0,0,1,.309-.461.505.505,0,0,1,.545.108l2.5,2.5a.5.5,0,0,1,0,.707l-2.5,2.5A.5.5,0,0,1,19,21.5a.489.489,0,0,1-.191-.038A.5.5,0,0,1,18.5,21V19.5a.25.25,0,0,0-.25-.25Z']],
  KeyboardAsterisk2: ['keyboard-asterisk-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.5,10.5a1,1,0,0,0-1-1H16.763a.25.25,0,0,1-.216-.375l2.868-4.968a1,1,0,0,0-.366-1.366l-2.6-1.5a1,1,0,0,0-1.366.366L12.217,6.622a.251.251,0,0,1-.434,0L8.915,1.654a1,1,0,0,0-1.366-.366l-2.6,1.5a1,1,0,0,0-.366,1.366L7.453,9.122a.25.25,0,0,1-.216.375H1.5a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1H7.237a.25.25,0,0,1,.216.375L4.585,19.84a1,1,0,0,0,.366,1.366l2.6,1.5a1,1,0,0,0,1.366-.366l2.868-4.968a.251.251,0,0,1,.434,0l2.868,4.968a1,1,0,0,0,1.366.366l2.6-1.5a1,1,0,0,0,.366-1.366l-2.868-4.968a.25.25,0,0,1,.216-.375H22.5a1,1,0,0,0,1-1Z']],
  KeyboardAsterisk1: ['keyboard-asterisk-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.691,16.7a1.333,1.333,0,0,0,1.285,2.336l8.32-4.576a.251.251,0,0,1,.371.219v7.989a1.333,1.333,0,1,0,2.666,0V14.675a.251.251,0,0,1,.371-.219l8.32,4.576A1.333,1.333,0,1,0,23.309,16.7l-8.144-4.479a.25.25,0,0,1,0-.439L23.309,7.3a1.333,1.333,0,1,0-1.285-2.336L13.7,9.539a.251.251,0,0,1-.371-.22V1.331a1.333,1.333,0,0,0-2.666,0V9.319a.251.251,0,0,1-.371.22L1.976,4.963A1.333,1.333,0,1,0,.691,7.3l8.144,4.479a.25.25,0,0,1,0,.439Z']],
  KeyboardAsterisk: ['keyboard-asterisk', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,12a1.224,1.224,0,0,0,1.224,1.225H8.44a.25.25,0,0,1,.177.427l-5.1,5.1a1.224,1.224,0,1,0,1.732,1.731l5.1-5.1a.25.25,0,0,1,.427.177v7.216a1.224,1.224,0,0,0,2.448,0V15.557a.25.25,0,0,1,.427-.177l5.1,5.1a1.224,1.224,0,1,0,1.732-1.731l-5.1-5.1a.25.25,0,0,1,.177-.427h7.216a1.225,1.225,0,0,0,0-2.449H15.559a.25.25,0,0,1-.177-.427l5.1-5.1a1.225,1.225,0,0,0-1.732-1.732l-5.1,5.1a.25.25,0,0,1-.427-.177V1.222a1.224,1.224,0,1,0-2.448,0V8.437a.25.25,0,0,1-.427.177l-5.1-5.1A1.225,1.225,0,0,0,3.515,5.244l5.1,5.1a.25.25,0,0,1-.177.427H1.224A1.224,1.224,0,0,0,0,12Z']],
  KeyboardArrowReturn1: ['keyboard-arrow-return-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.545,0H13.422a1.5,1.5,0,0,0,0,3H20.75a.25.25,0,0,1,.25.25V16.47a.25.25,0,0,1-.25.25H7.027a.25.25,0,0,1-.25-.25V13.442a1,1,0,0,0-1.707-.707L.293,17.513a1,1,0,0,0,0,1.414L5.07,23.7A1,1,0,0,0,5.777,24a.987.987,0,0,0,.383-.076A1,1,0,0,0,6.777,23V19.97a.25.25,0,0,1,.25-.25H21.545A2.458,2.458,0,0,0,24,17.264V2.453A2.459,2.459,0,0,0,21.545,0Z']],
  KeyboardCommand: ['keyboard-command', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.159,14.316H17.568a.25.25,0,0,1-.25-.25V9.929a.25.25,0,0,1,.25-.25h1.591a4.841,4.841,0,1,0-4.841-4.841V6.429a.25.25,0,0,1-.25.25H9.932a.25.25,0,0,1-.25-.25V4.838A4.841,4.841,0,1,0,4.841,9.679H6.432a.25.25,0,0,1,.25.25v4.137a.25.25,0,0,1-.25.25H4.841a4.841,4.841,0,1,0,4.841,4.841V17.566a.25.25,0,0,1,.25-.25h4.136a.25.25,0,0,1,.25.25v1.591a4.841,4.841,0,1,0,4.841-4.841ZM17.318,4.838a1.841,1.841,0,1,1,1.841,1.841H17.568a.25.25,0,0,1-.25-.25ZM3,4.838a1.841,1.841,0,0,1,3.682,0V6.429a.25.25,0,0,1-.25.25H4.841A1.843,1.843,0,0,1,3,4.838ZM6.682,19.157a1.841,1.841,0,1,1-1.841-1.841H6.432a.25.25,0,0,1,.25.25Zm3-9.228a.25.25,0,0,1,.25-.25h4.136a.25.25,0,0,1,.25.25v4.137a.25.25,0,0,1-.25.25H9.932a.25.25,0,0,1-.25-.25ZM19.159,21a1.844,1.844,0,0,1-1.841-1.84V17.566a.25.25,0,0,1,.25-.25h1.591a1.841,1.841,0,1,1,0,3.681Z']],
  KeyboardPageDown: ['keyboard-page-down', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.75,10.185a1.5,1.5,0,0,0,0-3h-3a.25.25,0,0,1-.25-.25V1.56a1.5,1.5,0,0,0-3,0V6.935a.25.25,0,0,1-.25.25h-3a1.5,1.5,0,0,0,0,3h3a.25.25,0,0,1,.25.25v1.25a.25.25,0,0,1-.25.25h-3a1.5,1.5,0,0,0,0,3h3a.25.25,0,0,1,.25.25v1.75a.25.25,0,0,1-.25.25h-3a1,1,0,0,0-.707,1.707l4.75,4.75a1,1,0,0,0,1.414,0l4.75-4.75a1,1,0,0,0-.707-1.707h-3a.25.25,0,0,1-.25-.25v-1.75a.25.25,0,0,1,.25-.25h3a1.5,1.5,0,0,0,0-3h-3a.25.25,0,0,1-.25-.25v-1.25a.25.25,0,0,1,.25-.25Z']],
  KeyboardPageUp: ['keyboard-page-up', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.75,12.06a1.5,1.5,0,0,0,0-3h-3a.25.25,0,0,1-.25-.25V7.06a.25.25,0,0,1,.25-.25h3A1,1,0,0,0,17.457,5.1L12.707.353a1,1,0,0,0-1.414,0L6.543,5.1A1,1,0,0,0,7.25,6.81h3a.25.25,0,0,1,.25.25V8.81a.25.25,0,0,1-.25.25h-3a1.5,1.5,0,0,0,0,3h3a.25.25,0,0,1,.25.25v1.25a.25.25,0,0,1-.25.25h-3a1.5,1.5,0,0,0,0,3h3a.25.25,0,0,1,.25.25v5.375a1.5,1.5,0,1,0,3,0V17.06a.25.25,0,0,1,.25-.25h3a1.5,1.5,0,1,0,0-3h-3a.25.25,0,0,1-.25-.25V12.31a.25.25,0,0,1,.25-.25Z']],
  KeyboardShift1: ['keyboard-shift-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.5,23.306a1,1,0,0,0,1-1V11.556a.249.249,0,0,1,.25-.25h3.258A1,1,0,0,0,21.7,9.583L12.691.967a1,1,0,0,0-1.382,0L2.3,9.583a1,1,0,0,0,.691,1.723H6.25a.249.249,0,0,1,.25.25v10.75a1,1,0,0,0,1,1Z']],
  KeyboardDeleteAlternate: ['keyboard-delete-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18,7.5H8.207a1.491,1.491,0,0,0-1.061.439l-3,3a1.5,1.5,0,0,0,0,2.121l3,3a1.488,1.488,0,0,0,1.061.44H18A1.5,1.5,0,0,0,19.5,15V9A1.5,1.5,0,0,0,18,7.5Zm-7.03,3.53a.75.75,0,1,1,1.061-1.06l.793.792a.25.25,0,0,0,.354,0l.792-.792a.75.75,0,1,1,1.061,1.06l-.793.793a.25.25,0,0,0,0,.354l.793.793a.75.75,0,1,1-1.061,1.06l-.792-.793a.252.252,0,0,0-.354,0l-.793.793a.75.75,0,0,1-1.061-1.06l.793-.793a.25.25,0,0,0,0-.354Z', 'M24,4.822A4.832,4.832,0,0,0,19.174,0H4.826A4.832,4.832,0,0,0,0,4.822V19.17A4.832,4.832,0,0,0,4.826,24H19.174A4.832,4.832,0,0,0,24,19.17ZM22,19.17A2.83,2.83,0,0,1,19.174,22H4.826A2.829,2.829,0,0,1,2,19.17V4.822A2.828,2.828,0,0,1,4.826,2H19.174A2.829,2.829,0,0,1,22,4.822Z']],
  KeyboardPowerOffAlternate: ['keyboard-power-off-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.174,0H4.826A4.832,4.832,0,0,0,0,4.822V19.17A4.832,4.832,0,0,0,4.826,24H19.174A4.832,4.832,0,0,0,24,19.17V4.822A4.832,4.832,0,0,0,19.174,0ZM22,19.17A2.83,2.83,0,0,1,19.174,22H4.826A2.829,2.829,0,0,1,2,19.17V4.822A2.828,2.828,0,0,1,4.826,2H19.174A2.829,2.829,0,0,1,22,4.822Z', 'M13.122,3.57a1,1,0,0,0-.262,1.982,6.5,6.5,0,1,1-7.235,7.72,1,1,0,1,0-1.961.391A8.5,8.5,0,1,0,13.122,3.57Z', 'M4.809,9.458A.513.513,0,0,0,5,9.5a.5.5,0,0,0,.353-.147L6.47,8.233a.251.251,0,0,1,.354,0l4.469,4.47a1,1,0,0,0,1.414-1.414L8.238,6.819a.249.249,0,0,1,0-.353L9.354,5.349A.5.5,0,0,0,9,4.5H5a.5.5,0,0,0-.5.5V9A.5.5,0,0,0,4.809,9.458Z']],
  KeyboardAltAlternate: ['keyboard-alt-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.174,0H4.826A4.832,4.832,0,0,0,0,4.822V19.17A4.832,4.832,0,0,0,4.826,24H19.174A4.832,4.832,0,0,0,24,19.17V4.822A4.832,4.832,0,0,0,19.174,0ZM22,19.17A2.83,2.83,0,0,1,19.174,22H4.826A2.829,2.829,0,0,1,2,19.17V4.822A2.828,2.828,0,0,1,4.826,2H19.174A2.829,2.829,0,0,1,22,4.822Z', 'M8.941,8.16a1,1,0,0,0-1.883,0l-2.5,7a1,1,0,0,0,1.883.672l.418-1.17A.25.25,0,0,1,7.1,14.5H8.9a.248.248,0,0,1,.235.166l.418,1.17a1,1,0,0,0,1.883-.672ZM7.633,12.5,8,11.469,8.366,12.5Z', 'M13.5,7.5a1,1,0,0,0-1,1v7a1,1,0,1,0,2,0v-7A1,1,0,0,0,13.5,7.5Z', 'M19,9.5h-.25a.25.25,0,0,1-.25-.25V8.5a1,1,0,0,0-2,0v.75a.25.25,0,0,1-.25.25H16a1,1,0,0,0,0,2h.25a.25.25,0,0,1,.25.25V14.5a2,2,0,0,0,2,2,1,1,0,0,0,.2-1.98.249.249,0,0,1-.2-.245V11.746a.25.25,0,0,1,.25-.25H19a1,1,0,0,0,0-2Z']],
  KeyboardArrowTopRight: ['keyboard-arrow-top-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.5,0H16.429a.5.5,0,0,0-.354.854l2.3,2.3a.252.252,0,0,1,0,.354L6.529,15.347A1.5,1.5,0,1,0,8.65,17.468L20.5,5.624a.249.249,0,0,1,.353,0l2.3,2.3a.5.5,0,0,0,.354.147.508.508,0,0,0,.191-.038A.5.5,0,0,0,24,7.569V.5A.5.5,0,0,0,23.5,0Z']],
  KeyboardArrowLeft: ['keyboard-arrow-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,10.5H7.027a.25.25,0,0,1-.25-.25V7.222A1,1,0,0,0,5.07,6.515L.292,11.293a1,1,0,0,0,0,1.414L5.07,17.485a1,1,0,0,0,.707.293,1,1,0,0,0,1-1V13.75a.25.25,0,0,1,.25-.25H22.5a1.5,1.5,0,0,0,0-3Z']],
  KeyboardArrowBottomRight: ['keyboard-arrow-bottom-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.383,15a1,1,0,0,0-1.09.217l-2.3,2.3a.25.25,0,0,1-.354,0L8.15,6.027A1.5,1.5,0,0,0,6.029,8.148L17.52,19.639a.249.249,0,0,1,0,.353l-2.3,2.3A1,1,0,0,0,15.929,24H23a1,1,0,0,0,1-1V15.926A1,1,0,0,0,23.383,15Z']],
  KeyboardArrowUp: ['keyboard-arrow-up', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.485,5.062,12.707.284a1.031,1.031,0,0,0-1.415,0L6.515,5.062a1,1,0,0,0,.707,1.707H10.25a.25.25,0,0,1,.25.25V22.492a1.5,1.5,0,1,0,3,0V7.019a.249.249,0,0,1,.25-.25h3.028a1,1,0,0,0,.707-1.707Z']],
  KeyboardReturn1Alternate: ['keyboard-return-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.174,0H4.826A4.832,4.832,0,0,0,0,4.822V19.17A4.832,4.832,0,0,0,4.826,24H19.174A4.832,4.832,0,0,0,24,19.17V4.822A4.832,4.832,0,0,0,19.174,0ZM22,19.17A2.83,2.83,0,0,1,19.174,22H4.826A2.829,2.829,0,0,1,2,19.17V4.822A2.828,2.828,0,0,1,4.826,2H19.174A2.829,2.829,0,0,1,22,4.822Z', 'M18.5,10.5H14.25a.25.25,0,0,1-.25-.25V8.5a1,1,0,0,0-1.707-.707l-3,3a1,1,0,0,0,0,1.414l3,3A1,1,0,0,0,14,14.5v-1.75a.25.25,0,0,1,.25-.25H18.5a1,1,0,0,0,0-2Z', 'M6.5,7.5a1,1,0,0,0-1,1v6a1,1,0,1,0,2,0v-6A1,1,0,0,0,6.5,7.5Z']],
  KeyboardEjectAlternate: ['keyboard-eject-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.174,0H4.826A4.832,4.832,0,0,0,0,4.822V19.17A4.832,4.832,0,0,0,4.826,24H19.174A4.832,4.832,0,0,0,24,19.17V4.822A4.832,4.832,0,0,0,19.174,0ZM22,19.17A2.83,2.83,0,0,1,19.174,22H4.826A2.829,2.829,0,0,1,2,19.17V4.822A2.828,2.828,0,0,1,4.826,2H19.174A2.829,2.829,0,0,1,22,4.822Z', 'M4.500 13.996 L19.500 13.996 L19.500 17.996 L4.500 17.996 Z', 'M5.654,12H18.346a.5.5,0,0,0,.364-.842L12.365,4.385a.5.5,0,0,0-.73,0L5.289,11.154A.5.5,0,0,0,5.654,12Z']],
  KeyboardArrowBottomLeft: ['keyboard-arrow-bottom-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.85,6.027,4.359,17.517a.25.25,0,0,1-.354,0l-2.3-2.3A1,1,0,0,0,0,15.926V23a1,1,0,0,0,1,1H8.071a1,1,0,0,0,.707-1.707l-2.3-2.3a.249.249,0,0,1,0-.353L17.971,8.148A1.5,1.5,0,0,0,15.85,6.027Z']]
};
exports["default"] = _default;